'use strict';

const localStorage = [
  'Storage',

  function (Storage) {
    return new Storage(Storage.hasLocalStorage ? 'local' : 'memory');
  }
];

export default localStorage;



// WEBPACK FOOTER //
// ./app/src/services/local_storage.js